body .front-page__container {
  background-color: #990ae3;
  min-height: 100%;
  padding: 1.6rem;

  @media screen and (min-width: 600px) {
    padding: 4.8rem 0;
  }

  @media screen and (min-width: 1024px) {
    padding: 6.5rem 0;
  }

  .front-page__panel-container {
    margin: 0 auto;

    width: 100%;

    @media screen and (min-width: 600px) {
      width: 75%;
    }

    @media screen and (min-width: 1024px) {
      width: 67%;
    }

    .front-page__panel {
      width: 100%;

      & > * {
        padding: 2.4rem 1.6rem;

        @media screen and (min-width: 600px) {
          padding: 2.4rem;
        }

        @media screen and (min-width: 1024px) {
          padding: 4.8rem;
        }
      }

      .front-page__header {
        padding-bottom: 0.8rem;

        @media screen and (min-width: 600px) {
          padding-bottom: 1.2rem;
        }

        @media screen and (min-width: 1024px) {
          padding-bottom: 1.6rem;
        }
      }

      .front-page__content {
        padding-top: 2.4rem;
        padding-bottom: 3.2rem;

        @media screen and (min-width: 600px) {
          padding-bottom: 4.8rem;
        }

        @media screen and (min-width: 1024px) {
          padding-bottom: 6.4rem;
        }
      }

      .front-page__search-input-container {
        width: 100%;

        @media screen and (min-width: 600px) {
          width: 70%;
        }

        @media screen and (min-width: 1024px) {
          width: 50%;
        }

        padding-top: 2.4rem;
      }
    }
  }
}
